import { useIntl } from 'react-intl';

import Lookup from 'src/componentes/select2';

const EstiloBorda = (props) => {
  const intl = useIntl();

  return (
    <Lookup
      clearable={false}
      labelKey="descricao"
      valueKey="id"
      options={[
        {
          id: 'none',
          descricao: intl.formatMessage({ id: 'nenhum' }),
        },
        {
          id: 'solid',
          descricao: intl.formatMessage({ id: 'linha' }),
        },
      ]}
      {...props}
    />
  );
};

export default EstiloBorda;
